import { Component, Input, Output, OnInit } from '@angular/core';
import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-color-picker',
	templateUrl: './color-picker.component.html',
	styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}

	setConfigColorValue(key, value) {
		let obj = {};
		obj[key] = value;
		this.config.patchValue(obj);
	}
}
